import { Snowplow2StatsDataTrackable } from './trackable';
import { StatsContextInterface } from '../../../stats/context.interface';
import { Snowplow2StatsAdapterSchemaAbTestsContext } from '../adapter/schema-ab-tests-context';

export class Snowplow2StatsDataPageView extends Snowplow2StatsDataTrackable {
  /**
   * @inheritDoc
   */
  constructor(context: StatsContextInterface) {
    super(context);

    // Ab tests context
    if (context.global.abTests) {
      this.contextSchemaList.push(new Snowplow2StatsAdapterSchemaAbTestsContext(context).getData());
    }
  }
}
